import http from "../http-common";

class CouponService {
    getByName(name, email) {
        return http.get(`/api/v1/coupons/name=${name}&email=${email}`);
    }
}

export default new CouponService();